// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Byte helpers shared by the signing modules. No dependencies.
/** Copies into a fresh Uint8Array backed by its own ArrayBuffer (WebCrypto and asn1js want exact buffers). */
export var toBytes = function (b) {
    return b instanceof ArrayBuffer
        ? new Uint8Array(b.slice(0))
        : new Uint8Array(b.buffer.slice(b.byteOffset, b.byteOffset + b.byteLength));
};
/** Exact-length ArrayBuffer for APIs that ignore byteOffset (asn1js valueHex, pkijs fromBER). */
export var toArrayBuffer = function (b) {
    return b.buffer.slice(b.byteOffset, b.byteOffset + b.byteLength);
};
export var hex = function (b) {
    var bytes = b instanceof Uint8Array ? b : new Uint8Array(b);
    var out = "";
    for (var i = 0; i < bytes.length; i++)
        out += bytes[i].toString(16).padStart(2, "0");
    return out;
};
/** "AB:CD:…" form of a lowercase hex fingerprint, as certificate viewers show it. */
export var colonHex = function (lowerHex) { var _a; return ((_a = lowerHex.match(/.{1,2}/g)) !== null && _a !== void 0 ? _a : []).join(":").toUpperCase(); };
export var sha256 = function (data_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([data_1], args_1, true), void 0, function (data, subtle) {
        var _a;
        if (subtle === void 0) { subtle = globalThis.crypto.subtle; }
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = Uint8Array.bind;
                    return [4 /*yield*/, subtle.digest("SHA-256", data)];
                case 1: return [2 /*return*/, new (_a.apply(Uint8Array, [void 0, _b.sent()]))()];
            }
        });
    });
};
export var bytesToBinaryString = function (b) {
    var s = "";
    for (var i = 0; i < b.length; i += 0x8000) {
        s += String.fromCharCode.apply(null, Array.from(b.subarray(i, i + 0x8000)));
    }
    return s;
};
export var binaryStringToBytes = function (s) {
    var out = new Uint8Array(s.length);
    for (var i = 0; i < s.length; i++)
        out[i] = s.charCodeAt(i) & 0xff;
    return out;
};
export var toBase64 = function (b) { return btoa(bytesToBinaryString(b)); };
export var fromBase64 = function (s) { return binaryStringToBytes(atob(s)); };
export var toPem = function (label, der) {
    var b64 = toBase64(der).replace(/(.{64})/g, "$1\n");
    return "-----BEGIN ".concat(label, "-----\n").concat(b64).concat(b64.endsWith("\n") ? "" : "\n", "-----END ").concat(label, "-----\n");
};
var derLength = function (n) {
    return n < 0x80 ? [n] : n < 0x100 ? [0x81, n] : [0x82, n >> 8, n & 0xff];
};
var derInteger = function (unsigned) {
    var i = 0;
    while (i < unsigned.length - 1 && unsigned[i] === 0)
        i++;
    var value = Array.from(unsigned.subarray(i));
    if (value[0] & 0x80)
        value.unshift(0);
    return [0x02].concat(derLength(value.length), value);
};
/**
 * WebCrypto ECDSA returns IEEE P1363 r||s (64 bytes for P-256). OpenSSL, X.509
 * and CMS want DER `ECDSA-Sig-Value ::= SEQUENCE { r INTEGER, s INTEGER }`.
 */
export var ecdsaRawToDer = function (raw) {
    if (raw.length === 0 || raw.length % 2 !== 0) {
        throw new Error("bad P1363 signature length ".concat(raw.length));
    }
    var n = raw.length / 2;
    var body = derInteger(raw.subarray(0, n)).concat(derInteger(raw.subarray(n)));
    return Uint8Array.from([0x30].concat(derLength(body.length), body));
};
